// extracted by mini-css-extract-plugin
export default {"tabPane":"styles_tabPane__-4t7R","tabs":"styles_tabs__H59me"};